/**
 * Sanitizes embed content to prevent XSS attacks while preserving legitimate scripts and styles
 * Custom implementation that only strips dangerous event handlers
 * @param html - The raw HTML content to sanitize
 * @returns The sanitized HTML content
 */
export const sanitizeEmbed = (html: string): string => {
	if (!html || typeof html !== 'string') {
		return '';
	}

	try {
		const dangerousHandlers = [
			'onerror',
			'onload',
			'onbeforeunload',
			'onunload',
			'onmessage',
		];

		const dangerousHandlerPattern = new RegExp(
			`\\s+(${dangerousHandlers.join('|')})\\s*=\\s*(?:"[^"]*"|'[^']*'|[^\\s>]*)`,
			'gi',
		);

		let sanitized = html.replace(dangerousHandlerPattern, '');

		sanitized = sanitized.replace(
			/\s+(href|src)\s*=\s*["']?\s*javascript:/gi,
			' $1=""',
		);

		return sanitized;
	} catch (error) {
		console.error('Custom sanitization error:', error);

		return '';
	}
};
